import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "layouts/Footer";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { useEffect, useState, useCallback } from "react";
import { getExcelData } from "./getExcelData";
import { companiesSync } from "rest/sync/requestsSync";
import { reportDetailCompanySales } from "rest/requests";
import { getQuarters } from "rest/requests";
import { formatResults } from "./formatResults";
import CommonSelect from "components/CommonSelect/select";
import TitleCustom from "components/CustomTitle";
import DataTable from "components/CustomDataTable/ProductsByCompaniesDataTable";
import { formatData } from "./formatDataForDataTable";

function buildExcellTitle(year, companiesCatalog, selectedCompany) {
  if (companiesCatalog.length > 0 && selectedCompany) {
    return (
      "Reporte_Productos_Por_Empresa_Año:" +
      year +
      "_Empresa:" +
      companiesCatalog.filter((elem) => elem.id === selectedCompany)[0].name +
      ".xlsx"
    );
  }
  return "ReporteProductosEmpresa.xlsx";
}

function ProductsByCompany() {
  const companiesCatalog = companiesSync();
  // ------ Year select ----------
  const [year, setYear] = useState(new Date().getFullYear());
  const handleYear = (event) => {
    const {
      target: { value },
    } = event;
    setYear(value);
  };
  // ------ Year select END----------

  const [selectedCompany, setSelectedCompany] = useState(null);
  const [products, setProducts] = useState([]);

  const getData = useCallback(async () => {
    if (String(year).length == 4 && selectedCompany) {
      const _companies = await reportDetailCompanySales(selectedCompany, year);
      const _quarters = await getQuarters(year);
      const quartersId = _quarters.length > 0 ? _quarters : [182, 64, 46, 47];
      const mappedResult = formatResults(_companies, quartersId);
      setProducts(mappedResult);
    }
  }, [year, selectedCompany]);

  useEffect(() => {
    getData();
  }, [year, selectedCompany]);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <TitleCustom
        title={"Reporte de Productos Por Empresa"}
        excelData={getExcelData(products)}
        excelName={buildExcellTitle(year, companiesCatalog, selectedCompany)}
      ></TitleCustom>

      <MDBox bgColor="white" variant="gradient" borderRadius="lg" shadow="lg" opacity={1} p={2}>
        <Grid container spacing={5}>
          <Grid item>
            <CommonSelect
              data={companiesCatalog}
              onChange={(selectedValue) => setSelectedCompany(selectedValue)}
            ></CommonSelect>
          </Grid>
          <Grid item>
            <MDInput type="number" label="Year" value={year} onChange={handleYear} />
          </Grid>
        </Grid>
      </MDBox>
      <br></br>
      {products.length > 0 ? (
        <DataTable table={formatData(products)} canSearch={true} />
      ) : (
        <MDTypography variant="overline">
          No existen datos para los filtros seleccionados
        </MDTypography>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default ProductsByCompany;
